import { first, map, take } from 'rxjs/operators'

import { SearchFeatured, getTranslatedString } from '@skinsoft/types'
import { getDateString } from '@skinsoft/utils';
import { conditionReportSelectors, institutionSelectors, thesaurusTermSelectors } from '@skinsoft/selectors'
import { InstitutionDataStore, ThesaurusTermDataStore, ConditionReportDataStore } from '@skinsoft/entity'


export async function resolveAuthorFunction(searchFeatured: SearchFeatured, locale: string): Promise<string> {
    const thesaurusDataStore: ThesaurusTermDataStore = ThesaurusTermDataStore.getInstance();

    if (!searchFeatured.credits || !searchFeatured.credits.authorFunction || typeof searchFeatured.credits.authorFunction !== 'string') {
        return "";
    }

    return thesaurusDataStore.fetchOne(searchFeatured.credits.authorFunction as string).pipe(
        take(1),
        map(thesaurusTerm => {
            const resolvedCredits = getTranslatedString(thesaurusTermSelectors.preferredTerm(thesaurusTerm), locale);
            return resolvedCredits;
        })).toPromise();
}

export async function resolveInstitution(searchFeatured: SearchFeatured, locale: string): Promise<string> {
    const institutionDataStore: InstitutionDataStore = InstitutionDataStore.getInstance();
    if (!searchFeatured.institution) {
        return "";
    }
    return institutionDataStore.fetchOne(searchFeatured.institution as string).pipe(
        take(1),
        map(institution => {
            const resolvedInstitution = institutionSelectors.title(institution, locale);
            return resolvedInstitution;
        })).toPromise()
}


export async function resolveDenomination(searchFeatured: SearchFeatured, locale: string): Promise<string> {
    const thesaurusDataStore: ThesaurusTermDataStore = ThesaurusTermDataStore.getInstance();
    if (!searchFeatured.denomination || typeof searchFeatured.denomination !== 'string') {
        return "";
    }

    return thesaurusDataStore.fetchOne(searchFeatured.denomination as string).pipe(
        take(1),
        map(thesaurusTerm => {
            const resolvedDenomination = getTranslatedString(thesaurusTermSelectors.preferredTerm(thesaurusTerm), locale)
            return resolvedDenomination;
        }))
        .toPromise()
}

export async function resolveDomain(searchFeatured: SearchFeatured, locale: string): Promise<string> {
    const thesaurusDataStore: ThesaurusTermDataStore = ThesaurusTermDataStore.getInstance();
    if (!searchFeatured.domain || typeof searchFeatured.domain !== 'string') {
        return "";
    }
    return thesaurusDataStore.fetchOne(searchFeatured.domain as string).pipe(
        take(1),
        map(thesaurusTerm => {
            const resolvedDomain = getTranslatedString(thesaurusTermSelectors.preferredTerm(thesaurusTerm), locale);
            return resolvedDomain;
        })).toPromise()
}


export async function resolveLastReportDate(searchFeatured: SearchFeatured, locale: string): Promise<string> {
    const conditionReportDataStore = ConditionReportDataStore.getInstance()
    if (!searchFeatured.lastConditionReportId) {
        return ""
    }
    
    return conditionReportDataStore.fetchOne(searchFeatured.lastConditionReportId).pipe(
        first(),
        map(
            conditionReport => {
                let formattedDate = ""
                const skindate = conditionReportSelectors.date(conditionReport) 
                formattedDate = getDateString(skindate, locale)
 
                return formattedDate
            }
        )).toPromise()
}